import React, { useRef } from 'react'
import {
    useHistory,
    Link,
    Route,
    Switch,
    useRouteMatch,
    useLocation,
} from 'react-router-dom'
import Header from '../Header'
import Subnav from '../../components/Subnav'
import { Desktop, Tablet, Mobile } from '../../utils/responsive'

import useQuery from './useQuery'
import Scans from './scans/Scans'
import Sales from './sales/Sales'

import { stringify } from '../../utils/querystring'

const navigationItems = ({ e: eventsToCompare }, location) =>
    [
        {
            title: 'Sales',
            icon: 'money',
            link: `/compare/sales?${stringify({
                e: eventsToCompare.map(e => ({ id: e.id })),
            })}`,
            isActive: true,
        },
        {
            title: 'Scans',
            icon: 'barcode',
            link: `/compare/scans?${stringify({
                e: eventsToCompare.map(e => ({ id: e.id })),
            })}`,
        },
    ].map(item => {
        let pathnameWithoutTrailingSlash = location.pathname.replace(/\/$/, '')
        let isActive = item.link.indexOf(pathnameWithoutTrailingSlash) !== -1

        return {
            ...item,
            isActive,
        }
    })

const EventSearchBox = () => {
    const history = useHistory()
    const input = useRef(null)

    return (
        <div className="sk-search-box">
            <form
                onSubmit={() =>
                    history.push(`/events?q=${input.current.value}`)
                }
            >
                <div className="sk-search-box__icon" />
                <input
                    type="text"
                    data-qa="query"
                    className="sk-search-box__text"
                    placeholder="Search"
                    ref={input}
                />
                <input
                    type="submit"
                    value="search"
                    className="sk-search-box__action"
                    data-qa="submit"
                />
                <div
                    data-qa="loader"
                    className="sk-search-box__loader sk-spinning-loader is-hidden"
                />
            </form>
        </div>
    )
}

const Navigation = ({ children }) => (
    <nav className="navbar-default navbar-static-side" role="navigation">
        {children}
    </nav>
)

const Page = ({ children }) => (
    <div id="page-wrapper" className="gray-bg">
        {children}
    </div>
)

const PageHeading = ({ title, children }) => (
    <div className="row wrapper border-bottom white-bg page-heading">
        <div className="col-lg-12">
            {title && <h2>{title}</h2>}
            {children}
        </div>
    </div>
)

const Layout = () => {
    let { path } = useRouteMatch()
    let location = useLocation()
    const queryParams = useQuery()

    const navigation = navigationItems(queryParams, location)
    const activeNavigationItem = navigation.find(n => n.isActive)

    return (
        <div id="wrapper">
            <Header search={<EventSearchBox />} />
            <Navigation>
                <ul className="nav metismenu" id="side-menu">
                    <li
                        className="nav-header"
                        style={{ paddingBottom: 0 }}
                    ></li>
                    {navigation.map(item => (
                        <li
                            key={item.title}
                            className={item.isActive ? 'active' : undefined}
                        >
                            <Link to={item.link}>
                                <i className={`fa fa-${item.icon}`} />
                                <span className="nav-label">{item.title}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </Navigation>
            <Page title="Event comparison">
                <PageHeading>
                    <div className="flex jc-space-between">
                        <div>
                            <h1>Compare {activeNavigationItem.title}</h1>
                            <Desktop>
                                <ol className="breadcrumb">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to={activeNavigationItem.link}>
                                            {activeNavigationItem.title}
                                        </Link>
                                    </li>
                                </ol>
                            </Desktop>
                        </div>
                    </div>
                    <Tablet>
                        <Subnav items={navigation} />
                    </Tablet>
                    <Mobile>
                        <Subnav items={navigation} />
                    </Mobile>
                </PageHeading>
                <Switch>
                    <Route path={`${path}/sales`}>
                        <Sales />
                    </Route>
                    <Route path={`${path}/scans`}>
                        <Scans />
                    </Route>
                </Switch>
            </Page>
        </div>
    )
}

export default Layout
